import { useNavigate } from 'react-router';
import { Button, Text } from '~/commonComponents';
import { getShouldEnforcePermanentJobV2 } from '~/growthbook';
import { useCreateDraftJobPost } from '~/domain/PermanentJobs';
import { showErrorMessage } from '~/domain/utils';
import { Colors } from '~/themes/colors';
import { type CSSProperties } from 'react';
import PlusIcon from '~/images/icons/PlusIcon';
import { ClipLoader } from 'react-spinners';

interface ICreatePostingButtonProps {
  text?: string;
  variant?: 'default' | 'lite';
}

const Styles = {
  Lite: {
    Button: {
      alignItems: 'center',
      backgroundColor: Colors.secondary_500,
      borderRadius: 25,
      boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.15), 0 6px 10px 2px rgba(0, 0, 0, 0.15)',
      display: 'inline-flex',
      flexShrink: 0,
      gap: 4,
      height: 30,
      justifyContent: 'center',
      padding: '8px 12px',
    } as CSSProperties,
  },
};

export const CreatePostingButton: React.FC<ICreatePostingButtonProps> = ({
  text = 'Post a Job',
  variant = 'default',
}: ICreatePostingButtonProps) => {
  const navigate = useNavigate();
  const createDraftJobPost = useCreateDraftJobPost();

  const handleCreateDraft = () => {
    createDraftJobPost.mutate(undefined, {
      onSuccess: (data) => {
        if (data?.id) {
          navigate(`/permanent-jobs/postings/${data.id}`);
        }
      },
      onError: (error) => {
        showErrorMessage({ error });
      },
    });
  };

  if (!getShouldEnforcePermanentJobV2()) {
    return null;
  }

  if (variant === 'lite') {
    return (
      <button
        data-testid="create-permanent-job-button"
        disabled={createDraftJobPost.isPending}
        style={Styles.Lite.Button}
        onClick={handleCreateDraft}
      >
        {createDraftJobPost.isPending ? (
          <ClipLoader size={16} color={Colors.white} loading />
        ) : (
          <PlusIcon color={Colors.white} />
        )}
        <Text bold color={Colors.white} textAlign="center">
          {text}
        </Text>
      </button>
    );
  }

  return (
    <Button
      data-testid="create-permanent-job-button"
      text={text}
      style={{ width: 206 }}
      isLoading={createDraftJobPost.isPending}
      onClick={handleCreateDraft}
    />
  );
};
